module.exports = __webpack_public_path__ + "static/media/LegoShadowTheatreINTA0068_design_clean_v001.08d6a08c.png";